import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { Splash } from "./Routes/Splash";
import { Classroom, UserProvider } from "./Routes/Classroom";
import { CardFlip } from "./Routes/CardFlip";
import { ValueSpectrum } from "./Routes/ValueSpectrum";
import { Timeline } from "./Routes/Timeline";
import { AdminView } from "./Routes/Admin";

function App() {
  return (
    <UserProvider>
      <Router>
        <Switch>
          <Route path="/classroom" exact={true}>
            <Classroom />
          </Route>
          <Route path="/cardflip" exact={true}>
            <CardFlip />
          </Route>
          <Route path="/timeline" exact={true}>
            <Timeline />
          </Route>
          <Route path="/valuespectrum" exact={true}>
            <ValueSpectrum />
          </Route>
          <Route path="/secret-admin" exact={true}>
            <AdminView />
          </Route>
          <Route>
            <Splash />
          </Route>
        </Switch>
      </Router>
    </UserProvider>
  );
}

export default App;
